import { Match } from '../../../api-types';
import capitalize from 'capitalize';
import React from 'react';

export const ConfirmWindowMatchContent: React.FunctionComponent<{ match: Match }> = ({ match }) => {
  return <>Are you sure you want to archive {capitalize(match.name)}?</>;
};
